import useSWR from 'swr';

import { SERVICES } from '@shared/constants/apiConfig';
import { IAllUsers } from '@shared/interfaces';
import { withQueryParams } from '@shared/commonFunctions';

export const useUsers = (fromViewAs?: boolean) => {
  const { data } = useSWR<IAllUsers>(withQueryParams(`/${SERVICES.USER}/users/allUsers`, {fromViewAs}, false));
  return { users: data };
};
